var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      !_vm.hideAddress
        ? _c(
            "b-col",
            { attrs: { cols: "12", md: _vm.md, lg: _vm.lg } },
            [
              _c(
                "b-form-group",
                {
                  class: { "form-group--error": _vm.addressError },
                  attrs: {
                    label:
                      _vm.$t("insert.warehouse.Address") +
                      (_vm.required ? " *" : "")
                  }
                },
                [
                  _c("b-form-textarea", {
                    attrs: { placeholder: "" },
                    model: {
                      value: _vm.selectedAddress,
                      callback: function($$v) {
                        _vm.selectedAddress = $$v
                      },
                      expression: "selectedAddress"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12", md: _vm.md, lg: _vm.lg } },
        [
          _c(
            "b-form-group",
            {
              class: { "form-group--error": _vm.cityError },
              attrs: {
                label:
                  _vm.$t("insert.warehouse.CityId") + (_vm.required ? " *" : "")
              }
            },
            [
              _c("v-select", {
                attrs: { options: _vm.cities, label: "Label" },
                on: { input: _vm.selectCity },
                model: {
                  value: _vm.selectedCity,
                  callback: function($$v) {
                    _vm.selectedCity = $$v
                  },
                  expression: "selectedCity"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12", md: _vm.md, lg: _vm.lg } },
        [
          _c(
            "b-form-group",
            {
              class: { "form-group--error": _vm.districtError },
              attrs: {
                label:
                  _vm.$t("insert.warehouse.DistrictId") +
                  (_vm.required ? " *" : "")
              }
            },
            [
              _c("v-select", {
                attrs: {
                  options: _vm.distiricts,
                  label: "Label",
                  disabled: !_vm.selectedCity || !_vm.selectedCity.DecimalValue
                },
                on: { input: _vm.selectDistrict },
                model: {
                  value: _vm.selectedDistrict,
                  callback: function($$v) {
                    _vm.selectedDistrict = $$v
                  },
                  expression: "selectedDistrict"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06439701", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06439701","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextAddress.vue
// module id = null
// module chunks = 